module.exports = __webpack_public_path__ + "static/img/135.0f08f00.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/digital/news/135.png
// module id = O726
// module chunks = 0